import _sortBy from 'lodash/sortBy'

import { RootState } from '..'

export const getGlobalScenes = (state: RootState) => Object.values(state.scenes.globalEntries)
export const getUserScenes = (state: RootState) => _sortBy(Object.values(state.scenes.entries), ['global'])

export const getError = (state: RootState) => state.scenes.error
export const getScenesList = (state: RootState) => state.scenes.scenesList.asMutable({ deep: true })
export const getTempComments = (state: RootState) => state.scenes.temporary.comments.asMutable({ deep: true })
export const getTempTags = (state: RootState) => state.scenes.temporary.tags.asMutable({ deep: true })
export const getTempTitle = (state: RootState) => state.scenes.temporary.title
export const getSavedSceneId = (state: RootState) => state.scenes.saveSceneId
export const getPendingExternalUpdate = (state: RootState) => state.scenes.pendingExternalUpdate
export const getPendingExternalRename = (state: RootState) => state.scenes.pendingExternalRename
export const getPendingExternalDelete = (state: RootState) => state.scenes.pendingExternalDelete
export const getShowExternalRenameNotification = (state: RootState) => state.scenes.showExternalRenameNotification
